import { Button, Flex, Text, Tooltip } from "@chakra-ui/react";
import StatusBadge from "components/badge/StatusBadge";
import { GENDER_TYPE_TAGS } from "constants/dbEnums";
import { USER_ROLES } from "constants/dbEnums";

export const userColumns = (classifiedItemAction) => {
  return [
  {
    Header: "ID",
    accessor: "_id",
    Cell: ({ value }) => <Text>{value}</Text>,
  },
  {
    Header: 'NAME',
    accessor: 'name',
    Cell: ({value,row}) => {
      return (
        <Flex gap={1} align="center" justify={"center"}>
          <a href={`/#/admin/ads?search_text=${row?.values?.phone}`}>
            {value}
          </a>
          {row?.original?.is_deleted && <StatusBadge status={"deleted"} />}
        </Flex>
      );
    },
  },
    {
      Header: "CURRENT PLAN",
      accessor: "plan",
      Cell: ({ value, row }) => {
        const phone = row?.original?.phone;
        return (
          <Flex align="center" justify={"center"}>
            {value ? (
              <a
                href={`/#/admin/subscriptions/?search_text=${phone}`}
                target="_blank"
                rel="noreferrer"
                cursor="pointer"
              >
                <StatusBadge label={value} />
              </a>
            ) : (
              <Text>-</Text>
            )}
          </Flex>
        );
      },
    },
    {
      Header: "LAST ACTIVITY",
      accessor: "last_activity_at",
    },
    {
      Header: "EMAIL",
      accessor: "email",
    },
    {
      Header: "PHONE",
      accessor: "phone",
      Cell: ({ value }) => (
        <a href={`/#/admin/ads?search_text=${value}`}>{value}</a>
      ),
    },
    {
      Header: "ROLE",
      accessor: "role",
      Cell: ({ value }) => (
        <Flex align="center" justify={"center"}>
          <Text>
            <StatusBadge status={USER_ROLES[value]} />
          </Text>
        </Flex>
      ),
    },
    {
      Header: "GENDER",
      accessor: "gender",
      Cell: ({ value }) => (
        <Flex align="center" justify={"center"}>
          <Text>{value !== "u" ? GENDER_TYPE_TAGS[value] : "-"}</Text>
        </Flex>
      ),
    },
    {
      Header: "IP ADDRESS",
      accessor: "signup_ip",
      Cell: ({ value }) =>
        value ? (
          <a
            href={`https://whatismyipaddress.com/ip/${value}`}
            target="_blank"
            rel="noreferrer"
            style={{ color: "#3182ce", textDecoration: "underline" }}
          >
            {value}
          </a>
        ) : (
          <Text>-</Text>
        ),
    },
    {
      Header: "Primary Role",
      accessor: "classified_primary_role",
      Cell: ({ value = "", row }) => (
        <button onClick={() => classifiedItemAction(row.original)}>
          <Text>{value || "-"}</Text>
        </button>
      ),
    },
    {
      Header: "Secondary Role",
      accessor: "classified_secondary_role",
      Cell: ({ value = "", row }) => (
        <button onClick={() => classifiedItemAction(row.original)}>
          <Text>{value || "-"}</Text>
        </button>
      ),
    },
    {
      Header: "Contact Limit Exhausted",
      accessor: "contact_view_limit_exhausted",
      Cell: ({ value, row }) => (
        <a
          href={`/#/admin/user-usage?searchText=${row.original.phone}`}
          target="_blank"
        >
          <Text color={value ? "green.500" : undefined} fontWeight={value ? "bold" : "normal"}>
            {value ? "Yes" : "No"}
          </Text>
        </a>
      ),
    },
    {
      Header: "Posting Limit Exhausted",
      accessor: "posting_limit_exhausted",
      Cell: ({ value = "", row }) => (
        <a
          href={`/#/admin/ads?search_text=${row.original.phone}`}
          target="_blank"
        >
          <Text>{value ? "Yes" : "No"}</Text>
        </a>
      ),
    },
    {
      Header: "AI Comment",
      accessor: "classified_comment",
      Cell: ({ value = "", row }) => (
        <Flex
          align="center"
          justify="center"
          onClick={() => classifiedItemAction(row.original)}
        >
          {value?.length > 30 ? (
            <Tooltip label={value} aria-label="A tooltip">
              {value?.length > 30 ? `${value?.slice(0, 30)}...` : value}
            </Tooltip>
          ) : (
            <Text>{value || "-"}</Text>
          )}
        </Flex>
      ),
    },
    {
      Header: "COMMENT",
      accessor: "comment",
      Cell: ({ value = "" }) => (
        <Flex align="center" justify="center">
          {value?.length > 20 ? (
            <Tooltip label={value} aria-label="A tooltip">
              {value?.length > 20 ? `${value?.slice(0, 20)}...` : value}
            </Tooltip>
          ) : (
            <Text>{value || "-"}</Text>
          )}
        </Flex>
      ),
    },
    {
      Header: "COMMENT INFO",
      accessor: "commented_by",
      Cell: ({ value, row }) => {
        const createdStr = row?.original?.commented_at;
        const updatedStr = row?.original?.comment_updated_at;
        if (!value && !createdStr && !updatedStr) return <Text>-</Text>;
        return (
          <Flex direction="column" align="center" justify="center">
            {value && <Text fontWeight="600">{value}</Text>}
            {createdStr && (
              <Text fontSize="0.65rem" color="gray.600">
                Created: {createdStr}
              </Text>
            )}
            {updatedStr && updatedStr !== createdStr && (
              <Text fontSize="0.65rem" color="gray.600">
                Updated: {updatedStr}
              </Text>
            )}
          </Flex>
        );
      },
    },
    {
      Header: "PLATFORM",
      accessor: "platform",
    },
    {
      Header: "Referrer",
      accessor: "referrer",
    },
    {
      Header: "EMAIL VERIFIED",
      accessor: "email_verified",
    },
    {
      Header: "SLUG URL",
      accessor: "slug_url",
    },
    {
      Header: "USERNAME",
      accessor: "username",
    },
    {
      Header: "ONBOARDING",
      accessor: "onboarding_completed",
    },
    {
      Header: "ACTIVE PROPERTIES",
      accessor: "active_properties",
    },
    {
      Header: "CREATED_AT",
      accessor: "created_at",
    }
  ];
};

export const userColumnConfig = [
  {
    Header: "FIRST NAME",
    accessor: "first_name",
  },
  {
    Header: "LAST NAME",
    accessor: "last_name",
  },
  {
    Header: "PHONE",
    accessor: "phone",
  },
  {
    Header: "PHONE VERIFIED",
    accessor: "phone_verified",
  },
  {
    Header: "EMAIL",
    accessor: "email",
  },
  {
    Header: "EMAIL VERIFIED",
    accessor: "email_verified",
  },
  {
    Header: "ROLE",
    accessor: "role",
  },
  {
    Header: "ONBOARDING COMPLETED",
    accessor: "onboarding_completed",
  },
  {
    Header: "CREATED AT",
    accessor: "created_at",
  },
  {
    Header: "CREATED BY",
    accessor: "created_by",
  },
  {
    Header: "IS CAREER ACCOUNT",
    accessor: "is_career_account",
  },
];
